import axios from 'axios';
import { requestHeaders } from '../helpers';
import config from '../config';

export const reportService = {
  getReportData,
  getReportCsv,
  getReportDataChart
}

function getReportData(data) {
  return axios.post(`${config.URL_BASE}/reports/${data.reportType}`, data, requestHeaders());
}


function getReportDataChart(data) {
  return axios.post(`${config.URL_BASE}/reports/${data.reportType}/chart`, data, requestHeaders());
}

function getReportCsv(data) {
  return axios.post(`${config.URL_BASE}/reports/${data.reportType}/csv`, data, requestHeaders());
}

/* 
function getReportData(data) {
  return axios.post(`${config.URL_BASE}/reports/${data.reportType}`, data, requestHeaders())
} */